import { OrderAdditon } from "./restaurant";

export class Category {
    Name: string;
    ID: number;
    categoryItems:CategoryItem[];
    isCheck:boolean;
    categoryType:number;
}

export class CategoryItem {
    ID:number;
    RstaurantID:number;
    ImageFile:string;
    Name:string;
    Header:string;
    Category:string;
    NameEn:string;
    CategoryEn:string;
    Rate:number;
    CountRate:number;
    ImageSize:number;
    IsFevorite:number;
    Kashrut:string;
    toppingsList:OrderAdditon[];
    IsFreeShipping:number;
    MinimumOrder:string;
    IsOpen:number;
}
export class categories
        {
          ID:number;
          Category:string;
          CategoryEn:string;
          Count:number;
          ImgFile:string;
        }

export class mainRestaurantItem {
    ID:number;
    RstaurantID:number;
    ImageFile:string;
    Name:string;
    Header:string;
    Category:string;
    NameEn:string;
    Rate:number;
    CountRate:number;
    ImageSize:number;
    IsFevorite:number;
    Kashrut:string;
    toppingsList:OrderAdditon[];
    IsFreeShipping:number;
    MinimumOrder:string;
    IsOpen:number;
    IsTemporaryClosed:number;
    DeliveryPrice:number;
    DeliveryTime:string;
}
export class MainListObject
{   list : mainRestaurantItem[];
    categories: categories [];
    ListID: number
    ListName:string;
    IsCategories: number;

    error:boolean;
    responseMessage:string;
}
export class MainObject {
    list:MainListObject[];
    error:boolean;
    responseMessage:string;
}

export class ListImage{
    list:ListImages[];
    error:boolean;
    responseMessage:string;
}
export class ListImages{
    BusinessUrl:string;
    ImageFile:string;
}

export class ItemCategory{
    ID:number;
    ImgFile:string;
    Category:string;
    Count:number
     CategoryEn:string;
}

export class FoodItem{
    price: number;
    foodName: string;
    amount: number;
}

export class AboutRestaurant
{
    aboutRestaurantId:number;
    aboutRestaurantName:string;
    isCheck:number;
}

